<!-- eslint-disable vue/no-v-html -->
<script>
import parseDate from 'date-fns/parse'
import differenceInDays from 'date-fns/difference_in_days'
import ExpertForm from './expert-form.vue'

import InputText from '@components/form/InputText'
import {
  projectsMethods,
  authMethods,
  methodologistMethods,
} from '@state/helpers'
import { min } from 'lodash'
// import { mapGetters } from 'vuex'
export default {
  name: 'Register',
  components: {
    ExpertForm,
    'input-text': InputText,
  },

  data() {
    return {
      termsAccepted: false,
      projectId: this.$route.params.project_id,
      loadingPage: false,
      gettingProfile: false,
      tryingToLogIn: false,
      currentProject: {},
      email: '',
      showExpertForm: false,
      showNextButton: false,
      password: 'expert1a2b',
      expertForm: {
        user: {
          username: '',
          password: 'expert1a2b',
          first_name: '',
          last_name: '',
        },
        institute: '',
        position: '',
        project: '',
        project_id: '',
        role: 1,
        is_evaluator: false,
      },
      emailError: '',
      showTermsModal: false,
    }
  },

  computed: {
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null
    },
    foreacastValidation() {
      const currentProject = this.currentProject.project
      if (!currentProject) return
      return (
        this.dateValidate(currentProject.end_date) < 0 &&
        currentProject.project_type === 1
      )
    },
  },

  mounted() {
    this.getPublicProject()
  },

  methods: {
    ...projectsMethods,
    ...authMethods,
    ...methodologistMethods,
    dateValidate(date) {
      const dateParsered = parseDate(date)
      const today = new Date()
      return differenceInDays(dateParsered, today)
    },

    async getPublicProject() {
      this.loadingPage = true
      const { status, data } = await this.findPublicProject(
        `?project_id=${this.projectId}`
      )
      this.loadingPage = false

      if (status !== 200) {
        return this.$router.push({ name: '404' })
      }

      if (data.project.project_type === 1) this.expertForm.role = 2

      this.currentProject = data
    },

    findAccents(text) {
      const accentArray = [
        'á',
        'à',
        'ã',
        'â',
        'é',
        'è',
        'ê',
        'í',
        'ì',
        'î',
        'õ',
        'ó',
        'ò',
        'ô',
        'ú',
        'ù',
        'û',
      ]

      for (const letter of text) {
        if (accentArray.includes(letter)) {
          this.emailError = 'El correo ingresado contiene tílde, debe retirarla'
          return true
        } else if (letter === 'ñ') {
          this.emailError = "El correo ingresado contiene 'ñ', debe retirarla"
          return true
        }
      }
      this.emailError = ''
      return false
    },

    async getProfile() {
      const email = this.email.toLowerCase()
      if (this.findAccents(email)) {
        this.$generate_toast(this, 'error', this.emailError)
        return
      }
      if (!this.termsAccepted) {
        this.$generate_toast(this, 'error', 'Es requerido aceptar política de protección de información')
        return
      }
      this.showExpertForm = false
      this.showNextButton = false
      this.gettingProfile = true

      const query = `?project_id=${this.currentProject.project.id}&email=${email}`
      // eslint-disable-next-line no-unused-vars
      const { status, data } = await this.findExpertPerProject(query)
      this.gettingProfile = false

      if (status === 404) {
        return (this.showExpertForm = true)
      }

      this.tryToLogIn()
    },

    async tryToRegister() {
      this.tryingToLogIn = true
      const email = this.email.toLowerCase()
      this.expertForm.user.username = email
      this.expertForm.user.email = email

      if (this.findAccents(email)) {
        this.$generate_toast(this, 'error', this.emailError)
        this.showExpertForm = false
        this.tryingToLogIn = false
        return
      }

      const form = {
        ...this.expertForm,
        project: this.currentProject.project.url,
        project_id: this.projectId,
      }

      const { status, data } = await this.createPublicExpert(form)

      this.tryingToLogIn = false

      if (status === 201) {
        const { username } = data.user
        const loginCredentials = {
          username: username,
          password: this.password,
        }
        return this.tryToLogIn(loginCredentials)
      }

      this.$generate_toast(this, 'error', 'Error de registro')
    },

    tryToLogIn(loginCredentials = {}) {
      const email = this.email.toLowerCase()
      if (this.findAccents(email)) {
        this.$generate_toast(this, 'error', this.emailError)
        this.showExpertForm = false
        this.tryingToLogIn = false
        return
      }

      this.tryingToLogIn = true
      const projectType = this.currentProject.project.project_type

      if (Object.entries(loginCredentials).length === 0) {
        loginCredentials = {
          username: email,
          password: this.password,
        }
      }

      const projectRouter = {
        name: 'expert.project.detail',
        params: { project_id: this.projectId },
      }

      if (projectType === 1) {
        projectRouter.name = 'pronostic.questions'
        projectRouter.params = { id: this.projectId }
      }

      const publicProject = {
        id: this.projectId,
        indexPath: projectRouter,
      }

      loginCredentials.publicProject = publicProject

      return this.logIn(loginCredentials)
        .then((token) => {
          this.tryingToLogIn = false
          this.$router.push(projectRouter)
        })
        .catch((error) => {
          this.tryingToLogIn = false
          const err = error.response
            ? error.response.data.non_field_errors[0]
            : error.message
          this.$generate_toast(this, 'error', err)
        })
    },

  },
}
</script>
<style lang="scss">
.login-image {
  display: inline-block;
  z-index: 5;
  min-height: 180px;
  max-height: 220px;
  width: 100%;
  // box-shadow: 0px 0px 2px 2px rgba(255, 255, 255, 0.4);
  border-radius: 10px;
  background-size: cover;
  background-position: center center;
  overflow: hidden;
  // background-color: #767f86;
}
</style>

<template>
  <div>
    <div v-if="loadingPage" class="text-center m-4">
      <b-spinner class="align-middle mr-2"></b-spinner>
      <strong>Cargando</strong>
    </div>
    <div v-else>
      <div class="row mt-4 justify-content-center">
        <div class="col-md-6 col-lg-5 col-xl-4 col-sm-9">
          <div class="card bg-pattern shadow-lg">
            <div class="card-body p-2">
              <div class="text-center m-auto px-3">
                <div v-if="currentProject && currentProject.project && currentProject.project.login_image"
                  class="login-image mt-2"
                >
                    <img :src="currentProject.project.login_image" alt="login" :height="220" />
                </div>
                <img v-else :src="
                  (getCompanyInfo &&
                  getCompanyInfo.light_logo) ||
                  require('@assets/images/triduum/triduum-logo.svg')
                " alt="login" :height="80" />

                <div v-if="currentProject.project" class="my-3">
                  <div class="h4">
                    {{ currentProject.project.name }}
                  </div>
                  <div v-if="currentProject.project.show_to">
                    <div class="text-left"><span v-html="currentProject.project.welcome_message"></span></div>
                    <!-- <a v-if="currentProject.project.instructions" target="_blank"
                      :href="currentProject.project.instructions" download="">Descargar
                      Instructivo</a> -->
                  </div>

                </div>
              </div>

              <div v-if="foreacastValidation">
                <b-alert show variant="danger">Pronóstico finalizado</b-alert>
              </div>

              <div v-else>
                <div class="p-2">
                  <label>Ingrese un correo electrónico para continuar</label>

                  <ValidationObserver v-slot="{ handleSubmit }">
                    <input-text name="email" label="" validate="email|required" :value.sync="email"
                      help-text="No puede contener tildes ni 'ñ'" />
                    <b-form-checkbox id="termsCheckbox" v-model="termsAccepted"  class="my-2" name="termsCheckbox">
                      Aceptar
                      <a class="text-blue" style="cursor:pointer" @click.prevent="showTermsModal = true">Política de
                        protección de información</a>
                    </b-form-checkbox>
                    <b-modal v-model="showTermsModal" ok-only ok-title="Cerrar"
                      title="POLÍTICA DE PROTECCIÓN DE INFORMACIÓN">
                      <div v-if="currentProject && currentProject.project && (!currentProject.project.terms_and_conditions || currentProject.project.terms_and_conditions === 'null' || currentProject.project.terms_and_conditions === '')">
                        <strong>Participación en el Estudio Prospectivo de la Policía Nacional Civil – Visión 2035</strong>
                        <p>
                          Queremos invitarle a formar parte de un ejercicio de construcción colectiva del futuro de su Policía Nacional Civil con miras al año 2035. Su participación es fundamental: sus respuestas reflejan su experiencia, visión y rol en la sociedad, y serán consideradas como aportes personales de gran valor para este estudio.
                        </p>
                        <p>
                          La información que usted comparta será tratada con absoluta confidencialidad. Los datos personales solicitados en este formulario se utilizarán exclusivamente para fines de análisis dentro del marco de este estudio prospectivo, realizado por la Institución, y como respaldo a su valiosa contribución.
                        </p>
                        <p>
                          Al finalizar el proceso, le compartiremos los resultados consolidados, incluyendo un análisis colectivo de los aportes generados en los diferentes ejercicios. De esta forma, podrá conocer cómo su participación ayudó a construir la visión compartida de la PNC que todos deseamos para el corto, mediano y largo plazo.
                        </p>
                        <p>
                          Agradecemos de antemano su confianza y compromiso con este importante ejercicio de futuro.
                        </p>
                      </div>
                      <div v-else v-html="currentProject && currentProject.project && currentProject.project.terms_and_conditions ? currentProject.project.terms_and_conditions : ''"></div>
                    </b-modal>

                    <b-button size="sm" text="Button" variant="primary" block
                      :disabled="gettingProfile || tryingToLogIn || !termsAccepted" @click=";[handleSubmit(getProfile)]">
                      <div v-if="gettingProfile || tryingToLogIn">
                        <b-spinner small class="mx-2"></b-spinner>
                      </div>
                      <div v-else> Enviar </div>
                    </b-button>
                  </ValidationObserver>
                </div>
                <div v-if="showExpertForm">
                  <ExpertForm :form="expertForm" :trying-to-log-in="tryingToLogIn" :try-to-register="tryToRegister" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div></template>
